
<!-------------------Banner starts------------------------------>

<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center w-100">

                <img src="../../../assets/images/banners/casestudy-banner.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="casestudy" />

                <img src="../../../assets/images/banners/casestudy-mobilebanner.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="casestudy" />

              
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-4 col-sm-6 banner-section">
                            <div class="align-items-center global_title global_banner_title ">
                                <span>Case Studies</span>
                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3">
                                <span> Read latest updates about
                                    enterprise insights, agile business, digital
                                    reimagination and assurance.</span>
                            </div>

                          
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-------------------Banner ends------------------------------>

<!--------------------Card Section starts--------------------->
<div class="container-fluid client-stories">
    <div class="blogs-bgimage">
        <div class="text-center pt-5 global_section_header" style="font-weight:400!important">Client Stories</div>
          <div class="container-fluid">
        <div class="row justify-content-center  ">
            <div class="col-12 col-lg-4 p-lg-3 p-2">
              <div class="course_card">
                <div class="course_card_img">
                  <img  src="../../../assets/images/casestudies/casestudy-curorc.png" alt="course">
                </div>
                <div class="course_card_content">
                    <h4 class="card-title pt-3">Cloud Computing</h4>
                    <h2 class="card-text  pt-3 text-black text-left">Supercharge with Cloud & Automation </h2>
                    <p class="casestudy-card-text global_section_content pt-3">Learn how Maganti IT partnered with a manufacturing client to build a resilient and future-ready, strategy-driven cloud infrastructure.</p>
                    
                  <!-- <h4 class="title">Angular Typescript</h4>
                  <h1 class="title">Angular Typescript</h1>

                  <p class="description">When we are no longer able to change a situation - we are challenged to change ourselves. Spread love everywhere you go. Let no one ever come to you without leaving happier. Problems are not stop signs, they are guidelines.</p> -->
                </div>
                <div class="course_card_footer">
                    <a href="sensor_manufacturing_managed_services_casestudy" class=" btn-read-more global_button text-center   text-white white_button crds4" style="background-color: #8522CF; margin-top: 20px">
                        <div class="dub-arrow">
                            <img src="../../../assets/images/button/arrowWhite.png" alt="arrowwhite" /></div>
                            READ MORE
                    </a>    
                  </div>
              </div>
            </div>
          
            <div class="col-12 col-lg-4 p-lg-3 p-2">
              <div class="course_card">
                <div class="course_card_img">
                  <img   src="../../../assets/images/casestudies/Machine-Learning.png" alt="course">
                </div>
                <div class="course_card_content">
                    <h4 class="card-title pt-3">Machine Learning</h4>
                    <h2 class="card-text  pt-3 text-black text-left">Machine learning-powered recommendation engines </h2>
                    <p class="casestudy-card-text global_section_content pt-3">Explore the forefront of innovation with Maganti IT as we redefine the landscape of manufacturing E-commerce personalisation.</p>
                     </div>
                <div class="course_card_footer">
                    <a href="/machine-learning" class=" btn-read-more global_button text-center   text-white white_button crds4" style="background-color: #8522CF; margin-top: 20px">
                        <div class="dub-arrow">
                            <img src="../../../assets/images/button/arrowWhite.png" alt="arrowwhite" /></div>
                            READ MORE
                    </a>    
                  </div>
              </div>
            </div>
          
            <div class="col-12 col-lg-4 p-lg-3 p-2">
              <div class="course_card">
                <div class="course_card_img">
                  <img  src="../../../assets/images/casestudies/ci-cd_casestudy.png" alt="course">
                </div>
                <div class="course_card_content">
                    <h4 class="card-title pt-3">Cloud Computing</h4>
                    <h2 class="card-text global_sub_title pt-3 text-black text-left">Customized CI/CD framework for a flawless Release Cycle</h2>
                    <p class="casestudy-card-text global_section_content pt-3">Discover the impact of our specialized CI/CD framework on accelerating application delivery for a sensor manufacturing company.</p>
                    </div>
                <div class="course_card_footer">
                    <a href="sensor_manufacturing_-ci_cd_casestudy" class=" btn-read-more global_button text-center   text-white white_button crds4" style="background-color: #8522CF; margin-top: 20px">
                        <div class="dub-arrow">
                            <img src="../../../assets/images/button/arrowWhite.png" alt="arrowwhite" /></div>
                            READ MORE
                    </a>          </div>
              </div>
            </div>
        



         
            <div class="col-12 col-lg-4 p-lg-3 p-2 ">
              <div class="course_card">
                <div class="course_card_img">
                  <img  src="../../../assets/images/casestudies/Pii-casestudy.png" alt="course">
                </div>
                <div class="course_card_content">
                    <h4 class="card-title pt-3">Artificial Intelligence/Machine Learning</h4>
                    <h2 class="card-text  pt-3 text-black text-left">Protecting Personal Identifiable Information (PII) using AI/ML</h2>
                    <p class="casestudy-card-text global_section_content pt-3">Discover how a wealth management institution leveraged automated data redaction AI for enhanced data privacy and proficient handling of personal information.</p>
                    
                  <!-- <h4 class="title">Angular Typescript</h4>
                  <h1 class="title">Angular Typescript</h1>

                  <p class="description">When we are no longer able to change a situation - we are challenged to change ourselves. Spread love everywhere you go. Let no one ever come to you without leaving happier. Problems are not stop signs, they are guidelines.</p> -->
                </div>
                <div class="course_card_footer">
                    <a routerLink="/pii-use-case-ai-ml" class=" btn-read-more global_button text-center   text-white white_button crds4" style="background-color: #8522CF; margin-top: 20px">
                        <div class="dub-arrow">
                            <img src="../../../assets/images/button/arrowWhite.png" alt="arrowwhite" /></div>
                            READ MORE
                    </a>    
                  </div>
              </div>
            </div>
          
            <div class="col-12 col-lg-4 p-lg-3 p-2">
              <div class="course_card">
                <div class="course_card_img">
                  <img   src="../../../assets/images/casestudies/casestudy-ouropinon.png" alt="course">
                </div>
                <div class="course_card_content">
                    <h4 class="card-title pt-3">Application Services</h4>
                    <h2 class="card-text  pt-3 text-black text-left">Innovation-led
                        application services </h2>
                    <p class="casestudy-card-text global_section_content pt-3">Learn how we built an all-in-one multi- faceted platform for CuroRc making it faster, convenient, more secure, and less expensive.</p>
                     </div>
                <div class="course_card_footer">
                    <a routerLink="/curorc" class=" btn-read-more global_button text-center   text-white white_button crds4" style="background-color: #8522CF; margin-top: 20px">
                        <div class="dub-arrow">
                            <img src="../../../assets/images/button/arrowWhite.png" alt="arrowwhite" /></div>
                            READ MORE
                    </a>    
                  </div>
              </div>
            </div>
          
            <div class="col-12 col-lg-4 p-lg-3 p-2">
              <div class="course_card">
                <div class="course_card_img">
                  <img  src="../../../assets/images/casestudies/casestudy-image.png" alt="course">
                </div>
                <div class="course_card_content">
                    <h4 class="card-title pt-3">Application Services</h4>
                    <h2 class="card-text global_sub_title pt-3 text-black text-left">Opinion polling
                        made seamless</h2>
                    <p class="casestudy-card-text global_section_content pt-3">Learn how we built a global website, with minimal downtime, with future cloud advances incorporated into  client's IT infrastructure.</p>
                    </div>
                <div class="course_card_footer">
                    <a routerLink="/ouropinion-casestudy" class=" btn-read-more global_button text-center   text-white white_button crds4" style="background-color: #8522CF; margin-top: 20px">
                        <div class="dub-arrow">
                            <img src="../../../assets/images/button/arrowWhite.png" alt="arrowwhite" /></div>
                            READ MORE
                    </a>          </div>
              </div>
            </div>
            <div class="col-12 col-lg-4 p-lg-3 p-2">
                <div class="course_card">
                  <div class="course_card_img">
                    <img  src="../../../assets/images/AI-casestudy-images/blog-image.png" alt="course">
                  </div>
                  <div class="course_card_content">
                      <h4 class="card-title pt-3">Artificial Intelligence Use-Case</h4>
                      <h2 class="card-text global_sub_title pt-3 text-black text-left">Real-Time Facial Expression Recognition and Annotation</h2>
                      <p class="casestudy-card-text global_section_content pt-3">Explore how we built FER with applications in personalized retail recommendations, emotion decoding in entertainment to marketing insights.</p>
                      </div>
                  <div class="course_card_footer">
                      <a routerLink="/ai-ml-use-case" class=" btn-read-more global_button text-center   text-white white_button crds4" style="background-color: #8522CF; margin-top: 20px">
                          <div class="dub-arrow">
                              <img src="../../../assets/images/button/arrowWhite.png" alt="arrowwhite" /></div>
                              READ MORE
                      </a>          </div>
                </div>
              </div>  </div>
         </div>  
</div>
</div>
<!--------------------Card Section ends--------------------->

